module.exports = "<div id=\"layout-main-content\" class=\"main-content\" [ngClass]=\"{'animated zoomIn': animated}\">\r\n  <ng-content></ng-content>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/trip2-theme/components/t2-content-main/t2-content-main.component.html
// module id = 2574
// module chunks = 66